// import fetch from '../utils/fetch';
import fetch,{ postFrom } from '../utils/fetch';

// 供应商列表查询
export function getList(params) {
    return fetch({
        method: 'GET',
        url: 'supplier/list',
        params
    })
}

// 获取全部供应商
export function getSuppliers() {
    return fetch({
        method: 'GET',
        url: 'supplier/all'
    })
}


// 获取供应商下的品牌
export function getBrand(params) {
    return fetch({
        method: 'GET',
        url: 'supplier/brand',
        params
    })
}

// 添加供应商
export function addSupplier(data) {
    return postFrom('supplier/add', data);
}

export function updateSupplier(data) {
  return postFrom('supplier/update',data)


}
